import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { LoyaltyCatalogCategoryGift } from 'app/models/loyalty-catalog-category-gift';
import { LoyaltyCatalogCategoryService } from 'app/services/loyalty/loyalty-catalog-category.service';
import { MessageService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-loyalty-catalog-category-form',
  templateUrl: './loyalty-catalog-category-form.component.html',
  styleUrls: ['./loyalty-catalog-category-form.component.css']
})
export class LoyaltyCatalogCategoryFormComponent implements OnInit {
  @Output() applicationAdded: EventEmitter<any> = new EventEmitter<any>();
  @Output() applicationUpdated: EventEmitter<any> = new EventEmitter<any>();
  @Input() dialogCategoryGift: LoyaltyCatalogCategoryGift;
  //@Input() editMode: boolean;
  addEditForm: FormGroup;
  invalidSubmit: boolean;
  validation: any;

  categoryGiftField: any;

  constructor(
    private fb: FormBuilder,
    private categoryGiftService: LoyaltyCatalogCategoryService,
    private message: MessageService,
    private router: Router
  ) {
    this.loadValidation();

    this.addEditForm = this.fb.group({
      code: '',
      progres: '',
      description: '',
    })
  }

  ngOnInit() {
  }

  /**
   * Carica i campi dal metodo getCategoryGift del Servizio LoyaltyCatalogCategoryService
   */
  loadValidation() {
    this.categoryGiftService.getCategoryGift().subscribe(res => {
      this.validation = res;
      console.log(this.validation)
    });
  }

  /**
   * Mi creo i campi del form di aggiunta/modifica
   * @param args 
   */
  ngOnChanges(...args: any[]) {
    this.addEditForm = this.fb.group({
      'code': new FormControl(this.dialogCategoryGift.code),
      'progres': new FormControl(this.dialogCategoryGift.progres),
      'description': new FormControl(this.dialogCategoryGift.description),
    });
  }

  /**
 * Metodo per la creazione o modifica di un record
 * @returns 
 */
  saveOrUpdate(dialogCategoryGift: any): void {
    if (!this.addEditForm.valid) {
      this.invalidSubmit = true;
      return;
    }
    this.invalidSubmit = false;

    let newData = Object.assign({}, this.dialogCategoryGift, this.addEditForm.value);
  
    if (this.dialogCategoryGift.id == null) {
      //this.categoryGiftService.post(newData).subscribe(() => {
        //this.message.add({ severity: 'success', summary: 'Success', detail: 'Category Saved' })
        this.applicationAdded.emit(newData);
      //});
    } else {
      //this.categoryGiftService.put(newData, this.dialogCategoryGift.id).subscribe(() => {
        //this.message.add({ severity: 'success', summary: 'Success', detail: 'Category Updated' })
        this.applicationUpdated.emit(newData);
      //});
    }
    
  }

}



// WEBPACK FOOTER //
// ./src/app/views/loyalty/loyalty-catalog-category/loyalty-catalog-category-form/loyalty-catalog-category-form.component.ts